/**
 * 首单订单成功页展示 OpenAppDownloadPopup 时，通过发布订阅通知全局抑制 ActivityWidget。
 * 订阅时会立即用当前值回调一次，避免「先发布、后订阅」导致丢状态（ActivityWidget 挂载晚于成功页子树）。
 */

type SuppressionListener = (suppressed: boolean) => void;

let suppressed = false;
const listeners = new Set<SuppressionListener>();

export function setActivityWidgetSuppressedForFirstOrder(value: boolean): void {
  if (suppressed === value) {
    return;
  }
  suppressed = value;
  listeners.forEach(fn => {
    try {
      fn(value);
    } catch {
      /* ignore */
    }
  });
}

export function getActivityWidgetSuppressedForFirstOrder(): boolean {
  return suppressed;
}

/** 取消订阅时返回 unsubscribe */
export function subscribeActivityWidgetFirstOrderSuppression(listener: SuppressionListener): () => void {
  listener(suppressed);
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
